module.exports = __webpack_public_path__ + "static/media/Avatar_20.b77421f0.svg";